/* eslint-disable */
import * as Types from './types';

import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { fetcher } from '../../fetcher';
export type FilterSettingsQueryVariables = Types.Exact<{
  id?: Types.InputMaybe<Types.Scalars['String']>;
  locale?: Types.InputMaybe<Types.Scalars['String']>;
}>;


export type FilterSettingsQuery = { __typename?: 'Query', filterSettings?: { __typename?: 'FilterSettings', filtersCollection?: { __typename?: 'FilterSettingsFiltersCollection', items: Array<{ __typename?: 'FilterSetting', searchParameter?: string | null, attribute?: string | null, label?: string | null, displaySwatches?: boolean | null, sys: { __typename?: 'Sys', id: string } } | null> } | null, nailArtFiltersCollection?: { __typename?: 'FilterSettingsNailArtFiltersCollection', items: Array<{ __typename?: 'FilterSetting', searchParameter?: string | null, attribute?: string | null, label?: string | null, displaySwatches?: boolean | null, sys: { __typename?: 'Sys', id: string } } | null> } | null, eduCourseFiltersCollection?: { __typename?: 'FilterSettingsEduCourseFiltersCollection', items: Array<{ __typename?: 'FilterSetting', searchParameter?: string | null, attribute?: string | null, label?: string | null, displaySwatches?: boolean | null, sys: { __typename?: 'Sys', id: string } } | null> } | null } | null };

export declare const filterSettings: import("graphql").DocumentNode;

export const FilterSettingsDocument = /*#__PURE__*/ `
    query filterSettings($id: String = "3THV6xgtkRG4FRcirYzYzN", $locale: String = "en-US") {
  filterSettings(id: $id, locale: $locale) {
    filtersCollection {
      items {
        sys {
          id
        }
        searchParameter
        attribute
        label
        displaySwatches
      }
    }
    nailArtFiltersCollection {
      items {
        sys {
          id
        }
        searchParameter
        attribute
        label
        displaySwatches
      }
    }
    eduCourseFiltersCollection {
      items {
        sys {
          id
        }
        searchParameter
        attribute
        label
        displaySwatches
      }
    }
  }
}
    `;
export const useFilterSettingsQuery = <
      TData = FilterSettingsQuery,
      TError = unknown
    >(
      dataSource: { endpoint: string, fetchParams?: RequestInit },
      variables?: FilterSettingsQueryVariables,
      options?: UseQueryOptions<FilterSettingsQuery, TError, TData>
    ) =>
    useQuery<FilterSettingsQuery, TError, TData>(
      variables === undefined ? ['filterSettings'] : ['filterSettings', variables],
      fetcher<FilterSettingsQuery, FilterSettingsQueryVariables>(dataSource.endpoint, dataSource.fetchParams || {}, FilterSettingsDocument, variables, options),
      options
    );

useFilterSettingsQuery.getKey = (variables?: FilterSettingsQueryVariables) => variables === undefined ? ['filterSettings'] : ['filterSettings', variables];
;

useFilterSettingsQuery.fetcher = (dataSource: { endpoint: string, fetchParams?: RequestInit }, variables?: FilterSettingsQueryVariables, options?: RequestInit['headers']) => fetcher<FilterSettingsQuery, FilterSettingsQueryVariables>(dataSource.endpoint, dataSource.fetchParams || {}, FilterSettingsDocument, variables, options);